import Instructor from "../../../assets/Images/Instructor.png";
import HighlightText from "../Homepage/HighlightText";
import CTAButton from "../Homepage/Button";
import { FaArrowRight } from "react-icons/fa";

const InstructorSection = () => {
  return (
    <div className="flex flex-col lg:flex-row gap-20 items-center">
      {/* left part */}
      <div className="lg:w-[50%]">
        <img
          src={Instructor}
          alt=""
          className="shadow-white shadow-[-20px_-20px_20px_0]"
        />
      </div>

      {/* right part */}
      <div className="lg:w-[50%] flex gap-10 flex-col">
        <h1 className="lg:w-[50%] text-4xl font-semibold ">
          Become an
          <HighlightText text={"Instructor"} />
        </h1>
        <p className="font-medium text-[16px] text-justify w-[90%] text-richblack-300">
          Instructors from around the world teach millions of students on
          Skillcode. We provide the tools and skills to teach what you love.
        </p>
        <div className="w-fit">
          <CTAButton active={true} linkto={"/signup"}>
            <div className="flex items-center gap-3">
              Start Learning Today <FaArrowRight />
            </div>
          </CTAButton>
        </div>
      </div>
    </div>
  );
};

export default InstructorSection;
